
/**
 * Module dependencies.
 */

import { Children, Component } from 'react';
import PropTypes from 'prop-types';

/**
 * Export `StickyNavbarProvider` component.
 */

export default class StickyNavbarProvider extends Component {

  /**
   * `childContextTypes` validation.
   */

  static childContextTypes = {
    isSticky: PropTypes.bool.isRequired,
    setSticky: PropTypes.func.isRequired
  };

  /**
   * `props` types.
   */

  props: {
    children: Element,
    isSticky: boolean
  };

  /**
   * Constructor.
   */

  constructor(props) {
    super(props);

    this.state = { isSticky: false };
  }

  /**
   * Get child context.
   */

  getChildContext() {
    return {
      isSticky: this.state.isSticky,
      setSticky: isSticky => this.setState({ isSticky })
    };
  }

  /**
   * Render.
   */

  render() {
    return Children.only(this.props.children);
  }

}



// WEBPACK FOOTER //
// ../src/client/components/core/sticky-navbar/sticky-navbar-provider.js